module.exports = __webpack_public_path__ + "img/target2.2b69fdb7.jpg";